module.exports = __webpack_public_path__ + "img/slide6.22689ece.jpg";